import { classNames } from "@opensea/ui-kit"

export const headerViewOverflowClassNames = classNames(
  "lg:pl-8 lg:[mask-image:linear-gradient(to_right,transparent,black_theme(spacing.8))]",
)
